import { render, staticRenderFns } from "./explain-header-download-button.component.vue?vue&type=template&id=1093f76e"
import script from "./explain-header-download-button.component.vue?vue&type=script&lang=ts"
export * from "./explain-header-download-button.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports